import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { applyPaypalCheckout } from "../../js/accounts";
import { activatePaidPlan } from "../../js/auth/authOnboarding";
import { reactivateDeskViaPayment, reactivateViaPaymentReturn } from "../../js/billing/billingDesk";
import { useAuth } from "../../js/hooks/useAuth";
import { useStore } from "../../js/state/store";

export default function CheckoutNotice() {
  const location = useLocation();
  const navigate = useNavigate();
  const { session } = useAuth();
  const { dispatch } = useStore();
  const [message, setMessage] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get("checkout") !== "success") return;
    const orderId = params.get("order") || "";
    const checkoutSession = session || {
      userId: params.get("user") || "",
      email: params.get("email") || "",
      role: params.get("role") || "agent",
      plan: params.get("plan") || "",
    };
    const result = applyPaypalCheckout(
      {
        orderId,
        userId: params.get("user") || session?.userId || "",
        planId: params.get("plan") || "",
        amount: params.get("amount") || "",
        payerEmail: params.get("email") || session?.email || "",
        role: params.get("role") || session?.role || "",
      },
      checkoutSession
    );
    const userId = params.get("user") || session?.userId || "";
    if (userId) {
      const next = session
        ? reactivateDeskViaPayment(session, result) ||
          activatePaidPlan(userId, { plan: params.get("plan") || session?.plan || "" })
        : null;
      if (next) dispatch({ type: "SET_SESSION", payload: next });
      else if (!session && userId) {
        reactivateViaPaymentReturn({ userId, role: params.get("role") || "agent" });
      }
    }
    setMessage(
      result?.duplicate
        ? "Payment was already recorded for that order."
        : "Payment received. Continue setup or open your desk when ready."
    );
    params.delete("checkout");
    params.delete("order");
    params.delete("amount");
    params.delete("email");
    params.delete("plan");
    params.delete("user");
    params.delete("role");
    const next = `${location.pathname}${params.toString() ? `?${params}` : ""}`;
    navigate(next, { replace: true });
  }, [dispatch, location.pathname, location.search, navigate, session]);

  if (!message) return null;
  return <p className="confirm-banner">{message}</p>;
}
